import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, InfoIcon, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { PreapprovalPeriodType } from '~/models/service-billing/model';
import pluralize from '~/utils/pluralize';
import styles from '../ServiceBuilder.module.scss';
import { getPreapprovedSuffix } from '../ServiceBuilder.utils';
import PreapprovalPeriodSelect from './PreapprovalPeriodSelect';
import PreapprovedTextField from './PreapprovedTextField';
export default function PreapprovedAmountSection() {
    const { t: preapprovalTexts } = useLocaleKeys('billing.preapproval');
    const { watch, setValue, getValues } = useFormContext();
    const [isPreapprovedEnabled, setIsPreapprovedEnabled] = useState(()=>{
        const cap = getValues('unitCap');
        return !!(cap && cap.trim() !== '' && +cap > 0);
    });
    const [unitCap, recurrencePeriod, pricing, unitName] = watch([
        'unitCap',
        'recurrencePeriod',
        'pricing',
        'unitName'
    ]);
    const isOnDemand = recurrencePeriod === 'onDemand';
    const suffixAmount = useMemo(()=>{
        if (isOnDemand) {
            return pricing === 'unit' ? pluralize(unitName) || preapprovalTexts.unitFallback.units() : preapprovalTexts.unitFallback.hours();
        }
        return getPreapprovedSuffix(recurrencePeriod);
    }, [
        recurrencePeriod,
        pricing,
        unitName,
        preapprovalTexts
    ]);
    const handlePreapprovedCheckboxChange = (checked)=>{
        setIsPreapprovedEnabled(checked);
        if (!checked) {
            setValue('unitCap', '', {
                shouldDirty: true
            });
            if (isOnDemand) {
                setValue('preapprovalPeriod', PreapprovalPeriodType.None, {
                    shouldDirty: true
                });
            }
        } else {
            if (isOnDemand) {
                setValue('preapprovalPeriod', PreapprovalPeriodType.Monthly, {
                    shouldDirty: true
                });
            }
            if (unitCap === '0') {
                setValue('unitCap', '', {
                    shouldDirty: true
                });
            }
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.preapprovedSection,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.checkboxRow,
                children: [
                    /*#__PURE__*/ _jsx(Checkbox, {
                        checked: isPreapprovedEnabled,
                        onChange: (e)=>handlePreapprovedCheckboxChange(e.target.checked),
                        testId: "preapproved-amount-checkbox"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        onClick: ()=>handlePreapprovedCheckboxChange(!isPreapprovedEnabled),
                        style: {
                            cursor: 'pointer'
                        },
                        children: preapprovalTexts.checkboxLabel()
                    }),
                    /*#__PURE__*/ _jsx(InfoIcon, {
                        testId: "sb-cap-info",
                        info: /*#__PURE__*/ _jsx("div", {
                            "data-testid": "sb-cap-tooltip",
                            children: preapprovalTexts.tooltip()
                        })
                    })
                ]
            }),
            isPreapprovedEnabled && /*#__PURE__*/ _jsxs("div", {
                className: styles.preapprovedFieldsRow,
                children: [
                    /*#__PURE__*/ _jsx(PreapprovedTextField, {
                        suffix: suffixAmount
                    }),
                    isOnDemand && /*#__PURE__*/ _jsx(PreapprovalPeriodSelect, {})
                ]
            })
        ]
    });
}
